import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination } from '@material-ui/core';
import { useAPI } from '../hooks/useApi'
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';


const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
});

export default function Users() {
    const classes = useStyles();
    const { get } = useAPI();
    const [users, setUsers] = useState([])
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [page, setPage] = React.useState(0);


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    useEffect(() => {
        get('authorization/getAll').then((response) => {
            console.log(response);
            if (response.status === true) {
                setUsers(response.users)
                console.log('başarılı');
            }
        })

    }, [])

    return (
        <Paper className={classes.paper}>
            <TableContainer >
                <Table className={classes.table} aria-label="simple table">
                    <TableHead>
                        <TableRow >
                            <TableCell align="left" style={{ fontWeight: 'bold' }}>İsim</TableCell>
                            <TableCell align="left" style={{ fontWeight: 'bold' }}>Soyisim</TableCell>
                            <TableCell align="left" style={{ fontWeight: 'bold' }}>Telefon Numarası</TableCell>
                            <TableCell align="left" style={{ fontWeight: 'bold' }}>E-mail</TableCell>
                            <TableCell align="left" style={{ fontWeight: 'bold' }}>Roller</TableCell>
                            <TableCell align="left" style={{ fontWeight: 'bold' }}>Aktiflik</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {users.map((row) => (
                            <TableRow>
                                <TableCell align="left">
                                    {row.firstname}
                                </TableCell>
                                <TableCell align="left">
                                    {row.lastname}
                                </TableCell>
                                <TableCell align="left">{row.phoneNumber}</TableCell>
                                <TableCell align="left">{row.email}</TableCell>
                                <TableCell align="left">{row.role}</TableCell>

                                <TableCell align="left">{row.active}
                                    {row.active === true ? (
                                        <CheckIcon style={{ color: '#27BF60' }} />
                                    ) : <ClearIcon style={{ color: 'red' }} />}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 50]}
                component="div"
                count={users.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
            />
        </Paper>
    )
}